import { APP_NAME, PLAYSTORE_URL } from 'constants/app';
import { MAX_LENGTH } from 'constants/size';
import { Platform } from 'react-native';

export const MESSAGE_SHARE_THIS_APP = `#${APP_NAME} ${PLAYSTORE_URL}`;

export const MESSAGE_SAVE_SUCCESS =
	Platform.OS === 'android' ? 'ギャラリーに保存しました' : '保存しました';
export const MESSAGE_SAVE_FAIL = '保存できませんでした...orz';

export const MESSAGE_HELP_TITILE = '使い方';
export const MESSAGE_HELP_CONTENTS = [
	'自由に入力した文字から、ファミコン時代のRPGみたいな画像が作れます。',
	'作った画像は保存したりシェアしたりできます。',
	'入力できる文字は以下です。（漢字は入力できません）',
	'　・全角ひらがな',
	'　・全角カタカナ',
	'　・英数字',
	'　・句読点、スペース、記号',
	'　・改行（セリフのみ）',
].join('\n');

export const MESSAGE_PLACEHOLDER = {
	name: `${MAX_LENGTH.NAME}もじいない ひらがな/カタカナ/えいすうじ/きごう`,
	job: `${MAX_LENGTH.JOB}もじいない ひらがな/カタカナ/えいすうじ/きごう`,
	sex: `${MAX_LENGTH.SEX}もじいない ひらがな/カタカナ/えいすうじ/きごう`,
	serif:
		'もじすうせいげんなし ひらがな/カタカナ/えいすうじ/きごう/かいぎょう',
};

export const MESSAGE_LEVEL_UP = (nextLevel: number): string => {
	return `レベルが${nextLevel}にあがった！`;
};
export const MESSAGE_HP_INCREASED = (plusHp: number): string => {
	return `さいだいＨＰが${plusHp}ふえた！`;
};
export const MESSAGE_MP_INCREASED = (plusMp: number): string => {
	return `さいだいＭＰが${plusMp}ふえた！`;
};
